import {ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Company} from "../../../../interfaces/company.interface";
import { getAssistantPromptByTag } from 'src/app/utils/assistant-prompt.util';
import * as ApexCharts from "apexcharts";

@Component({
  selector: 'app-expertise',
  templateUrl: './expertise.component.html',
  styleUrls: ['./expertise.component.scss']
})
export class ExpertiseComponent implements OnInit, OnDestroy {

  @Input() edit: boolean | undefined;
  @Input() reportSearch: any;
  @Input() company: Company;

  private chartOptions: any = null;

  private chart: ApexCharts;
  areas_of_expertise: { series: any[]; labels: string[] } = { series: [], labels: [] };
  private expertiseAreasFound = false;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    // this.chartOptions = this.getChartOptions();
  }

  /**
   * Called whenever the @Input() properties of the component change.
   * @param changes SimpleChanges - Object containing the changed inputs.
   */
  /*
  ngOnChanges(changes: SimpleChanges): void {
    // console.log('[expertise.component.ts] ngOnChanges')

    if (changes['company'] && changes['company'].currentValue) {
      const previousValue = changes['company'].previousValue;
      const currentValue = changes['company'].currentValue;

      const previousPrompt = previousValue?.assistant_prompts.find((item: any) => item.tag === 'ASK_ASSISTANT_EXPERTISE_AREAS');
      const currentPrompt = currentValue?.assistant_prompts.find((item: any) => item.tag === 'ASK_ASSISTANT_EXPERTISE_AREAS');
      if (!previousPrompt || previousPrompt !== currentPrompt) {

        // Destroy the existing chart if it exists
        if (this.chart) {
          this.chart.destroy();
          this.chart = null; // Reset chart reference
        }

        const prompt = currentValue.assistant_prompts.find((item: any) => item.tag === 'ASK_ASSISTANT_EXPERTISE_AREAS');
        if (prompt) {
          this.initApexCharts(currentValue);
          this.expertiseAreasFound = true;
        } else {
          this.expertiseAreasFound = false; // Reset flag if no expertise areas found
        }

      }

    }

  }
  */

  ngOnDestroy(): void {

    if (this.chart) {
      this.chart.destroy();
    }

    if ( this.chartOptions) {
      this.chartOptions = null;
    }

  }

  /*
  initApexCharts(company: any) {
    // console.log('[expertise.component.ts] initApexCharts')

    if (company) {

      // Retrieve the assistant prompt content for the specified tag
      const promptContent = getAssistantPromptByTag(company, 'ASK_ASSISTANT_EXPERTISE_AREAS');
      if (promptContent) {
        // this.getAreasOfExpertise(promptContent);
      }

    }

  }
  */

  /*
  getAreasOfExpertise(areasOfExpertise: any): void {
    try {
      if (areasOfExpertise && this.isValidJSON(areasOfExpertise)) {
        this.areas_of_expertise = JSON.parse(areasOfExpertise);
      } else {
        throw new Error("Invalid JSON format");
      }
    } catch (error) {
      console.error("[getAreasOfExpertise] Failed to parse JSON", error);
      this.areas_of_expertise = { series: [], labels: [] }; // Fallback to empty data
    }

    // this.getAreasOfExpertiseChart();
  }
  */

  isValidJSON(jsonString: string): boolean {
    try {
      JSON.parse(jsonString);
      return true;
    } catch (error) {
      return false;
    }
  }

  /*
  getAreasOfExpertiseChart() {
    // console.log('[expertise.component.ts getAreasOfExpertiseChart]')

    // Check if the chart container exists
    if (document.querySelector("#areas-of-expertise-chart")) {

      // Trigger change detection
      this.cdr.detectChanges();

      // Ensure areas_of_expertise is defined before accessing properties
      if (this.areas_of_expertise && this.areas_of_expertise.series && this.areas_of_expertise.labels) {
        // Business tenure chart
        this.chartOptions.series = this.areas_of_expertise.series;
        this.chartOptions.labels = this.areas_of_expertise.labels;
        this.chartOptions.chart.type = "donut";
        this.chartOptions.colors = [];
        this.chartOptions.chart.height = "300px";

        if (window.innerWidth < 768) {
          this.chartOptions.legend.position = "bottom";
          this.chartOptions.legend.offsetY = 0;
        } else {
          this.chartOptions.legend.position = "right";
          this.chartOptions.legend.offsetY = 50;
        }

        this.chart = new ApexCharts(document.querySelector("#areas-of-expertise-chart"), this.chartOptions);
        this.chart.render();
      } else {
        console.error('areas_of_expertise is undefined or does not have series/labels');
      }
    } else {
      console.log('Element #areas-of-expertise-chart does not exist!');
    }
  }
  */

  /*
  getChartOptions = () => {
    return {
      series: [],
      colors: ["#F86C25"],
      chart: {
        height: "200px",
        width: "100%",
        type: "radialBar",
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        radialBar: {
          track: {
            background: '#E5E7EB',
          },
          dataLabels: {
            show: false,
          },
          hollow: {
            margin: 0,
            size: "32%",
          }
        },
        pie: {
          donut: {
            labels: {
              show: true,
              name: {
                show: true,
                fontFamily: "Inter, sans-serif",
                offsetY: 20,
              },
              total: {
                showAlways: true,
                show: true,
                fontFamily: "Inter, sans-serif",
              },
              value: {
                show: true,
                fontFamily: "Inter, sans-serif",
                offsetY: -20,
              },
            },
            size: "80%",
          },
        },
      },
      grid: {
        show: false,
        strokeDashArray: 4,
        padding: {
          left: 2,
          right: 2,
          bottom: 50,
        },
      },
      labels: ["Business Tenure Score"],
      legend: {
        show: true,
        position: "bottom",
        fontFamily: "Inter, sans-serif",
      },
      tooltip: {
        enabled: true,
        x: {
          show: false,
        },
      },
      yaxis: {
        show: false,
        labels: {
          // formatter: function (value) {
          //   return value + '%';
          // }
        },
      },
      xaxis: {
        show: false,
        labels: {
          // formatter: function (value) {
          //   return value + '%';
          // }
        },
      }
    }
  }
  */

}
